export default __webpack_public_path__ + "locales/it/DeleteProfileEverDialog.json?hash=3b925ab85e30fb843d060011652787a5";